import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// Extensiones necesarias para manejar correctamente la quincena según zona horaria local
dayjs.extend(utc)
dayjs.extend(timezone)

export const BUSINESS_TZ = 'America/Argentina/Buenos_Aires'

// Helper para obtener dayjs en la zona horaria de negocio
export const dz = (value?: string | number | Date) =>
  value ? dayjs(value).tz(BUSINESS_TZ) : dayjs().tz(BUSINESS_TZ)

export default dayjs
